exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".experience-section[data-v-c6bb3600]{width:100vw;padding:60px 30px}.experience-section .section-title[data-v-c6bb3600]{text-align:center;text-transform:uppercase;letter-spacing:3px;font-size:2.5rem}.experience-section .event-header[data-v-c6bb3600]{font-size:1.125rem;color:grey;font-style:italic}.experience-section .event-text[data-v-c6bb3600]{padding:0 16px 16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6bb3600","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Experience.vue
// module id = 58
// module chunks = 0